import Vue from 'vue'

Vue.filter('money', (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  }).format(value)
})

Vue.filter('time', (value, full = true) => {
  if (!value || value === '') return '- -'
  if (full) {
    return window.moment(value, 'DD/MM/YYYY H:m:s').calendar(null, {
      sameDay: '[Hoje] [às] HH:mm',
      nextDay: '[Amanhã] [às] HH:mm',
      nextWeek: 'DD/MM/YY [às] HH:mm',
      lastDay: '[Ontem] [às] HH:mm',
      lastWeek: 'DD/MM/YY [às] HH:mm',
      sameElse: 'DD/MM/YY [às] HH:mm'
    })
  } else {
    return window.moment(value, 'DD/MM/YYYY').calendar(null, {
      sameDay: '[Hoje]',
      nextDay: '[Amanhã]',
      nextWeek: 'DD/MM/YY',
      lastDay: '[Ontem]',
      lastWeek: 'DD/MM/YY',
      sameElse: 'DD/MM/YY'
    })
  }
})

Vue.filter('integer', (value) => {
  return parseInt(value, 10)
})

Vue.filter('limit', (value, size) => {
  if (value.length < size) return value
  return value.substring(0, size) + '...'
})

Vue.filter('phone', (value) => {
  if (!value) return value
  value = value.replace(/[^0-9]/g, '')
  if (value.substr(0, 1) === '(' && value.substr(3, 1) === ')') {
    if (value.length > 14) return value.substr(0, 14)
    if (value.length === 14) return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1)$2-$3')
    if (value.length === 13) return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1)$2-$3')
  } else {
    value = value.replace(/[^0-9]/g, '')
    if (value.length === 11) return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1)$2-$3')
    if (value.length === 10) return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1)$2-$3')
  }
  return value
})



// WEBPACK FOOTER //
// ./src/filters.js